import { TaskBallColor } from '../enums/TaskBallColor';

export const defaultBallColors = [
  { label: '#E64036', rgb: { r: 230, g: 64, b: 54 } },
  { label: '#F9B035', rgb: { r: 249, g: 176, b: 53 } },
  { label: '#16B377', rgb: { r: 22, g: 179, b: 119 } },
  { label: '#326BBA', rgb: { r: 50, g: 107, b: 186 } },
  { label: '#684AA9', rgb: { r: 104, g: 74, b: 169 } },
  { label: '#A349AB', rgb: { r: 163, g: 73, b: 171 } },
  { label: '#FFFFFF', rgb: { r: 255, g: 255, b: 255 } },
  { label: '#BAB9B9', rgb: { r: 186, g: 185, b: 185 } },
  { label: '#2A292A', rgb: { r: 42, g: 41, b: 42 } },
];

export const legacyDefaultColors = [
  { value: TaskBallColor.Red, label: '#B85450' },
  { value: TaskBallColor.Purple, label: '#9673A6' },
  { value: TaskBallColor.Blue, label: '#6C8EBF' },
  { value: TaskBallColor.Silver, label: '#FFF' },
];
